module.exports = __webpack_public_path__ + "img/02.84c1f78c.jpg";